import { Phone } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { PHONE_TEL, WHATSAPP_URL } from "@/lib/contact";
import { track } from "@/lib/track";

export const PhoneCTA = ({ location, label = "Appeler AVELIS", className = "", iconClass = "h-4 w-4" }) => (
  <a
    href={PHONE_TEL}
    data-testid={`cta-phone-${location}`}
    onClick={() => track(`click_phone_${location}`)}
    className={`btn-primary ${className}`}
  >
    <Phone className={iconClass} strokeWidth={2.2} />
    {label}
  </a>
);

export const WhatsAppCTA = ({ location, label = "Envoyer un message", className = "", iconClass = "h-4 w-4" }) => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`cta-whatsapp-${location}`}
    onClick={() => track(`click_whatsapp_${location}`)}
    className={`btn-whatsapp ${className}`}
  >
    <WhatsAppIcon className={iconClass} />
    {label}
  </a>
);
